/** Client-side mirror of the password policy enforced by the backend. */
export const MIN_PASSWORD_LENGTH = 12;
